"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = useTrackingWriteKey;

var _react = _interopRequireDefault(require("react"));

var _trackingKeyProvider = require("@vp/tracking-key-provider");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function useTrackingWriteKey(defaultWriteKey, tenant, culture, environment) {
  const [writeKey, setWriteKey] = _react.default.useState(defaultWriteKey || null);

  _react.default.useEffect(() => {
    if (defaultWriteKey) {
      return;
    }

    (0, _trackingKeyProvider.getWriteKey)(tenant, getCountry(culture), environment).catch(error => console.error(`Unable to fetch tracking write key ${error}. Tracking will not load.`)).then(newWriteKey => setWriteKey(newWriteKey));
  }, []);

  return writeKey;
}

function getCountry(culture) {
  if (!culture) {
    return undefined;
  }

  const parsed = culture.split("-");
  return parsed.length > 1 ? parsed[parsed.length - 1] : undefined;
}